import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { personalInfo } from '../../data/content';

const CallWidget = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const pulsingAnimation = {
    scale: [1, 1.2, 1],
    boxShadow: [
      "0 0 0px 0px rgba(255, 215, 0, 0)",
      "0 0 20px 5px rgba(255, 215, 0, 0.4)",
      "0 0 0px 0px rgba(255, 215, 0, 0)"
    ]
  };

  return (
    <div 
      className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-[60] flex items-end"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="relative flex items-center">
        {/* Pulsing Phone Icon */}
        <motion.div
          animate={pulsingAnimation}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="w-14 h-14 bg-brand-yellow text-brand-dark flex items-center justify-center rounded-full shadow-2xl cursor-pointer z-20"
        >
          <SafeIcon name="Phone" className="w-6 h-6 fill-current" />
        </motion.div>

        {/* Hover Content Box */}
        <AnimatePresence>
          {isHovered && (
            <motion.div
              initial={{ opacity: 0, x: -20, scale: 0.95 }}
              animate={{ opacity: 1, x: 10, scale: 1 }}
              exit={{ opacity: 0, x: -20, scale: 0.95 }}
              className="ml-4 bg-brand-dark dark:bg-brand-darker text-white p-6 rounded-2xl shadow-2xl border border-brand-yellow/30 w-[calc(100vw-5rem)] sm:w-72 pointer-events-auto"
            >
              <div className="relative">
                <span className="text-[10px] uppercase tracking-widest text-brand-yellow font-bold block mb-1">
                  Connect Directly
                </span>
                <h4 className="text-sm font-heading font-bold mb-4">
                  Let's Discuss Your Stack
                </h4>

                <div className="flex flex-col gap-3">
                  <a
                    href={personalInfo.calendar}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-brand-cyan text-brand-dark text-xs uppercase font-bold tracking-widest rounded hover:bg-brand-yellow transition-colors"
                  >
                    <SafeIcon name="Calendar" className="w-4 h-4" /> Book a Call
                  </a>

                  <a
                    href={`tel:${personalInfo.phone}`}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-transparent border-2 border-brand-yellow text-brand-yellow text-xs uppercase font-bold tracking-widest rounded hover:bg-brand-yellow/10 transition-colors"
                  >
                    <SafeIcon name="PhoneCall" className="w-4 h-4" /> Call Right Now
                  </a>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CallWidget;